<!--
 * @Author: xiaokun
 * @Date: 2020-04-13 16:13:40
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-04 14:46:54
 * @Description: 右侧审批操作
 -->
<template>
  <div
    ref="approveOptions"
    class="right-approve-options"
  >
    <back-to-top
      :bottom="60"
      @to-top="onToTop"
    />
    <div
      v-for="(item,index) in questionList"
      :key="item._id"
    >
      <approve-question-item
        :item-data="item"
        :is-approve="isApprove"
        @handle-score="getTotalScore"
      >
        <span slot="question-serial-number">{{ index+1 }}、</span>
      </approve-question-item>
    </div>
    <div class="no-more-data">
      已无更多数据
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import ApproveQuestionItem from './approve-question-item'
import BackToTop from '@components/back-to-top'
export default {
  name: 'RightApproveOptions',
  components: { ApproveQuestionItem, BackToTop },
  props: {
    // 是否为查看
    isApprove: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      // 问题列表
      questionList: []
    }
  },
  watch: {},
  created () {
    this.paperEmployeePaperQuestionGetParams()
  },
  methods: {
    // 存入 审批实时计算总分
    ...mapMutations('examination-manage', {
      setCurTotalScore: 'SET_CURTOTALSCORE'
    }),
    // 接口参数
    paperEmployeePaperQuestionGetParams () {
      this.params = {
        paperId: this.$route.query.paperId,
        taskId: this.$route.query.taskId,
        employeeId: this.$route.query.employeeId
      }
      this.paperEmployeePaperQuestionGet()
    },
    // 获取 审批 右侧该用户所答内容获得分数
    async paperEmployeePaperQuestionGet () {
      let res = await MBASVCAPIS.PaperApi.paperEmployeePaperQuestionGet(this.params)
      if (res.success) {
        // 为审批时，初始化计数器的值
        if (this.isApprove) {
          res.data.data.forEach(item => {
          // 初始化为undefined 为了将计数器的值置为空
            item.score = undefined
          })
        }
        this.questionList = res.data.data
      } else {
      }
    },
    // 计算当前总数，用于左侧 总数展示
    getTotalScore () {
      let score = 0
      this.questionList.forEach(item => {
        score = score + (item.score || 0)
      })
      // 将分数存入vuex 左侧从vuex中获取
      this.setCurTotalScore(score)
    },
    getQuestionList () {
      let questions = []
      this.questionList.forEach(item => {
        questions.push({ score: item.score, paperQuestionId: item.paperQuestionId })
      })
      return questions
    },
    // 回到顶部
    onToTop () {
      this.$refs.approveOptions.scrollTop = 0
    }
  }
}
</script>
<style lang='scss' scoped>
.right-approve-options {
  width: 100%;
  height: calc(100vh - 212px);
  overflow-y: scroll;

  .no-more-data {
    text-align: center;
    font-size: 13px;
    color: #a1a1a1;
    padding: 12px 0;
  }
}
</style>
